(function($){
    'use strict';
  
    if(!$.gnv){
        $.gnv = new Object();
    };
  
    $.gnv.alertClose =  function (){
  
      $(".b-lol_alert__close").click(function(e){
        e.preventDefault();
        $(this).parent('.b-lol_alert').hide();
        
      });
  
    };
  
})(jQuery);
  